/**
 * Helpers puros do Resumable Upload (Meta Graph).
 * Sem HTTP / endpoints — só parsing e MIME.
 */

export function resolveHeaderMediaMimeType(file: File): string {
  const mime = String(file.type || "").trim().toLowerCase();
  if (mime) return mime;

  const name = file.name.toLowerCase();
  if (name.endsWith(".png")) return "image/png";
  if (name.endsWith(".jpg") || name.endsWith(".jpeg")) return "image/jpeg";
  if (name.endsWith(".mp4")) return "video/mp4";
  if (name.endsWith(".pdf")) return "application/pdf";
  return "application/octet-stream";
}

export function extractResumableUploadHandle(raw: unknown): string | null {
  if (!raw || typeof raw !== "object") return null;
  const envelope = raw as Record<string, unknown>;

  if (typeof envelope.h === "string" && envelope.h.trim()) {
    return envelope.h.trim();
  }

  const data = envelope.data;
  if (data && typeof data === "object") {
    const nested = (data as Record<string, unknown>).h;
    if (typeof nested === "string" && nested.trim()) return nested.trim();
  }

  return null;
}

export function extractResumableUploadSessionId(raw: unknown): string | null {
  if (!raw || typeof raw !== "object") return null;
  const envelope = raw as Record<string, unknown>;

  if (typeof envelope.id === "string" && envelope.id.trim()) {
    return envelope.id.trim();
  }

  const data = envelope.data;
  if (data && typeof data === "object") {
    const nested = (data as Record<string, unknown>).id;
    if (typeof nested === "string" && nested.trim()) return nested.trim();
  }

  return null;
}

export function extractGraphApiErrorMessage(raw: unknown): string | null {
  if (!raw || typeof raw !== "object") return null;
  const envelope = raw as Record<string, unknown>;

  const error = envelope.error;
  if (error && typeof error === "object") {
    const message = (error as Record<string, unknown>).message;
    if (typeof message === "string" && message.trim()) return message.trim();
  }

  if (typeof envelope.message === "string" && envelope.message.trim()) {
    return envelope.message.trim();
  }

  return null;
}
